import { render } from "./ForgotPasswordVerifyComponent.vue?vue&type=template&id=834f54be"
import script from "./ForgotPasswordVerifyComponent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerifyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/ForgotPasswordVerifyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "834f54be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('834f54be', __exports__)) {
    api.reload('834f54be', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordVerifyComponent.vue?vue&type=template&id=834f54be", () => {
    api.rerender('834f54be', render)
  })

}


export default __exports__